import { useTranslation } from 'react-i18next';
import Button from '../../../../../../../common/widgets/Button';
import Dialog from '../../../../../../../common/widgets/Dialog';
import Icons from '../../../../../../../common/widgets/Icons';
import { EmployeeTemplateOptionModel } from '../../../../../models/EmployeeTemplateOptionModel';
import { resources } from '../../../../../resources/resources';

interface AddOptionsDialogProps {
  options: EmployeeTemplateOptionModel[];
  addOption: (option: EmployeeTemplateOptionModel) => void;
  close: () => void;
}

export default function AddOptionsDialog(
  props: Readonly<AddOptionsDialogProps>,
) {
  const { options, addOption, close } = props;
  const { t: translate } = useTranslation();
  return (
    <div>
      <Dialog
        closeDialog={close}
        showCloseIcon
        closeOnClickOutside
        className="dialog-m"
      >
        <div className="dialog-content">
          <div className="dialog-title">
            {translate(resources.admin.fileImport.editTemplate.dialogTitle)}
          </div>
          <ul className="add-columns-list">
            {options.map(o => {
              return (
                <li key={o.optionId}>
                  <Icons.DashboardCircle />
                  <p>{o.name.toUpperCase()}</p>
                  <Button
                    className="btn btn-sm btn-template"
                    onClick={() => addOption(o)}
                    icon={<Icons.AddButtonAlt />}
                  >
                    <span className="btn-text">
                      {translate(
                        resources.admin.fileImport.editTemplate.actions.add,
                      )}
                    </span>
                  </Button>
                </li>
              );
            })}
          </ul>
        </div>
      </Dialog>
    </div>
  );
}
